import React, {useEffect,useRef, useState} from "react";
import {  useParams } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import $ from 'jquery';
import socketIOClient from "socket.io-client";


import PostHolder from "../components/PostHolder";
import CommentHolder from "../components/CommentHolder";

import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';

import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';

import hashtag from '../media/instruction/hashtag.gif';
import vote from '../media/instruction/vote.gif';
import updown from '../media/instruction/updown.gif';
import hashtagExample from '../media/instruction/hashtag-example.png';
import flag from '../media/instruction/flag.png';
import reason from '../media/instruction/flag-reason.png';
import ButtonGroup from '@material-ui/core/ButtonGroup';



import useReaction from '../useReaction';

const useStyles = makeStyles((theme) => ({
      root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
      },
      commentinput:{
        marginBottom: 20,
        borderRadius: 0,
        paddingLeft: 16,
        paddingRight: 16
      },
      input:{
        width: '100%',  
      },
      authorinfo:{
        marginBottom: 5,
        display: 'flex'
    },img:{
      maxWidth: '80%'
    },
    li:{
      paddingBottom: '10px'
    }  
}));

// socket 
const SOCKET_SERVER_URL ="http://13.124.5.10:4000";

const ADD_COMMENT_EVENT = "addComment";
const DELETE_COMMENT_EVENT = "deleteComment";
const ADD_REPLY_EVENT = "addReply";
const DELETE_REPLY_EVENT = "deleteReply";
const CHANGE_HASHTAG_VOTE_EVENT="changeHashtagVote";
const ADD_HASHTAG_EVENT="addHashtag";
const CHANGE_UPDOWN_VOTE_EVENT="changeUpDownVote";



export default function Post(props) {
  let { postno} = useParams();
  let condition='text'
  //const {comments, addComment, deleteComment, addReply, deleteReply, changeHashtagVote, addHashtag, changeUpDownVote} = useReaction(postno, group);        
  const classes=useStyles();
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
//  const [comments, setComments] = useState([]);
  const [input, setInput] = useState('');
  const [validity, setValidity] = useState(false);
    //socket 
  const [comments, setComments] = useState([]); // Sent and received messages

  const socketRef = useRef();

  const username=localStorage.getItem('username');
  const displayname=localStorage.getItem('displayname');
  

  const handleChange = event => {
    var inputval=event.target.value;
    setInput(inputval);
    setValidity((inputval.length>5));
  }

  const handleAddComment=()=>{
    addComment(condition, username, input);

    setInput('');
    setValidity(false);
    $('#comment-input').val('');
  }

  const handleDeleteComment=(comment_id)=>{
    const username = localStorage.getItem('username');
    deleteComment(username, comment_id);
    
  }

  const getComments = () =>{
    const username = localStorage.getItem('username');
    const token = localStorage.getItem('token');
    $.ajax({
      url:'/api/get-comments/',
      method: 'GET',
      data: {'post_no': postno, 'username': username, 'token': token},
      success: function(res){
        setComments(res.comments);
      },
      error: function(err){
        console.log('error!')
      },
    })
  }

  useEffect(()=>{
      $.ajax({
        url:'/api/get-post/',
        method: 'GET',
        data: {'post_no':postno},
        success: function(res){
          setTitle(res.post.title);
          setBody(res.post.body);
        },
        error: function(err){
          console.log('error!')
        },
      })
      const username=localStorage.getItem('username');
      $.ajax({
        url:'/api/get-comments/',
        method: 'GET',
        data: {'post_no': postno, 'username': username, 'condition':condition},
        success: function(res){
          setComments(res.comments);
        },
        error: function(err){
          console.log('error!')
        },
      })

     // getComments();
    socketRef.current = socketIOClient(SOCKET_SERVER_URL, {
      query: {
          postno: postno,
          condition: condition
    }})
 

    socketRef.current.on(ADD_COMMENT_EVENT, (comment) => {
      if(comment.newcomment.condition==condition){
        if(comment.newcomment.postno==postno){
        setComments((comments) => [...comments, comment.newcomment]);
        }}
      });

    socketRef.current.on(DELETE_COMMENT_EVENT, (deleted) => {
        setComments((comments) => comments.filter(item=>item.id!==deleted.id));
        });

    socketRef.current.on(ADD_REPLY_EVENT, (reply) => {
        setComments((comments) => {
            let curcomment=comments.find(comment => comment.id===reply.comment_id);
            if(curcomment!==undefined){
                curcomment.replies= [...curcomment.replies, reply.newreply];
            }
            return [...comments]})
        });

    socketRef.current.on(DELETE_REPLY_EVENT, (reply) => {
        setComments((comments) => {
            let curcomment=comments.find(comment => comment.id===reply.comment_id);
            if(curcomment!==undefined){
                curcomment.replies=curcomment.replies.filter(item=>item.id!==reply.id);
            }
            return [...comments]})
        });
    
    socketRef.current.on(CHANGE_HASHTAG_VOTE_EVENT, (data) => {
      const receiver=localStorage.getItem('username')
        setComments((comments)=>{
          let curcomment=comments.find(comment => comment.id===data.comment_id);
          if(curcomment!==undefined){
            if(data.direction==='up'){
              let curhashtag=curcomment.hashtags.pos.find(hashtag => hashtag.id===data.hashtag_id);
              if(data.is_cancel){
                curhashtag.votes=curhashtag.votes-1;
                if(curhashtag.votes<=0){
                  curcomment.hashtags.pos=curcomment.hashtags.pos.filter(hashtag => hashtag.id !== data.hashtag_id);
                }else{
                if(receiver===data.sender){
                  curhashtag.voted=false;
                }}
              }else{
                curhashtag.votes=curhashtag.votes+1;
                if(receiver===data.sender){
                  curhashtag.voted=true;
                }
              }
              return [...comments]
            }else{
              let curhashtag=curcomment.hashtags.neg.find(hashtag => hashtag.id===data.hashtag_id);
              if(data.is_cancel){
                curhashtag.votes=curhashtag.votes-1;
                if(curhashtag.votes<=0){
                  curcomment.hashtags.neg=curcomment.hashtags.neg.filter(hashtag => hashtag.id !== data.hashtag_id);
                }else{
                if(receiver===data.sender){
                  curhashtag.voted=false;
                }}
              }else{
                curhashtag.votes=curhashtag.votes+1;
                if(receiver===data.sender){
                  curhashtag.voted=true;
                }
              }
              return [...comments]}
          }else{
            return [...comments]
          }
        })
      });

      socketRef.current.on(ADD_HASHTAG_EVENT, (data) => {
        const receiver=localStorage.getItem('username')
        setComments((comments)=>{
            let curcomment=comments.find(comment => comment.id===data.comment_id);
            if(curcomment!==undefined){
              if(data.direction==='up'){
                const newhashtag=data.newhashtag
                if(receiver!==data.sender){
                  newhashtag.voted=false;
                }
                curcomment.hashtags.pos = [...curcomment.hashtags.pos, newhashtag]
                return [...comments]
              }else{
                const newhashtag=data.newhashtag
                if(receiver!==data.sender){
                  newhashtag.voted=false;
                }
                curcomment.hashtags.neg = [...curcomment.hashtags.neg, newhashtag]
                return [...comments]
              }}else{
                return [...comments]
              }
            })
        });

        socketRef.current.on(CHANGE_UPDOWN_VOTE_EVENT, (data) => {
          const receiver=localStorage.getItem('username')
            setComments((comments)=>{
              let curcomment=comments.find(comment => comment.id===data.comment_id);
              if(curcomment!==undefined){
                if(data.direction==='up'){
                  let curvote=curcomment.updownvotes.upvotes;
                  if(data.is_cancel){
                    curvote.count=Math.max(curvote.count-1,0);
                    if(receiver===data.sender){
                      curvote.voted=false;
                    }
                  }else{
                    curvote.count=curvote.count+1;
                    if(receiver===data.sender){
                      curvote.voted=true;
                    }
                  }
                  return [...comments]
                }else{
                  let curvote=curcomment.updownvotes.downvotes;
                  if(data.is_cancel){
                    curvote.count=Math.max(curvote.count-1,0);
                    if(receiver===data.sender){
                      curvote.voted=false;
                    }
                  }else{
                    curvote.count=curvote.count+1;
                    if(receiver===data.sender){
                      curvote.voted=true;
                    }
                  }
                  return [...comments]
              }}else{
                return [...comments]
              }
              })
          });
    
    return () => {
        socketRef.current.disconnect();
        };
  }, [postno]);

  const addComment = (condition, username, input) => {
    console.log(condition,'condition' )
    $.ajax({
        url:'/api/add-comment/',
        method: 'POST',
        data: {'post_no': postno, 'condition':condition, 'username': username, 'text': input},
        success: function(res){
            socketRef.current.emit(ADD_COMMENT_EVENT, {
                newcomment: res.comment
            });
    },
        error: function(err){
          console.log('error!')
        },
      })
  };

  const deleteComment = (username, comment_id) => {
    $.ajax({
        url:'/api/delete-comment/',
        method: 'POST',
        data: {'comment_id': comment_id, 'username': username},
        success: function(){
            socketRef.current.emit(DELETE_COMMENT_EVENT, {
                id: comment_id
            });
     },
        error: function(err){
          console.log('error!')
        },
      })
  };

  const addReply = (username, comment_id, replyinput) =>{
    console.log('usrename' ,username)
    $.ajax({
        url:'/api/add-reply/',
        method: 'POST',
        data: {'comment_id': comment_id, 'username': username, 'text': replyinput},
        success: function(res){
            socketRef.current.emit(ADD_REPLY_EVENT, {
                comment_id: comment_id,
                newreply: res.reply
            });
    },
        error: function(err){
          console.log('error!')
        },
      })
  };
  const deleteReply = (username,comment_id, reply_id) =>{
    $.ajax({
        url:'/api/delete-reply/',
        method: 'POST',
        data: {'reply_id': reply_id, 'username': username},
        success: function(){
            socketRef.current.emit(DELETE_REPLY_EVENT, {
                comment_id: comment_id, 
                id: reply_id
            })
        },
        error: function(err){
          console.log('error!')
        },
      })
  };

  const changeHashtagVote = (username,comment_id, direction, hashtag_id, voted) =>{
    $.ajax({
      url:'/binarytext/change-vote/',
      method: 'POST',
      data: {'hashtag_id': hashtag_id, 'username': username, 'current':voted},
      success: function(res){
        socketRef.current.emit(CHANGE_HASHTAG_VOTE_EVENT, {
          comment_id: comment_id, 
          direction: direction, 
          hashtag_id: hashtag_id,
          sender: username, 
          is_cancel: voted
      })
      },
      error: function(err){
          console.log('error!')
      },
    })
  };

  const addHashtag = (username,comment_id, direction, label) =>{
    $.ajax({
      url:'/binarytext/add-hashtag/',
      method: 'POST',
      data: {'comment_id':comment_id, 'username': username,'label': label, 'direction':direction},
      success: function(res){
        socketRef.current.emit(ADD_HASHTAG_EVENT, {
          newhashtag: res.hashtag,
          comment_id: comment_id, 
          direction: direction, 
          sender: username, 
      })
      },
      error: function(err){
          console.log('error!')
      },
    })
  };

  const changeUpDownVote = (username,comment_id, direction, voted) =>{
    $.ajax({
      url:'/binary/change-vote/',
      method: 'POST',
      data: {'comment_id': comment_id, 'username': username, 'direction': direction, 'current': voted},
      success: function(res){
        socketRef.current.emit(CHANGE_UPDOWN_VOTE_EVENT, {
          comment_id: comment_id, 
          direction: direction, 
          sender: username, 
          is_cancel: voted
      })
      },
      error: function(err){
        console.log('error!')
      },
    })
  };

  return (
    <div>
      <PostHolder title={title} body={body}/>
      {comments.map((comment, idx)=>{
        return(
          <CommentHolder comment={comment} key={idx} postno={postno} displayname={displayname} username={username} is_removable={username===comment.username} deleteFunc={()=>handleDeleteComment(comment.id)} condition={condition} addReply={addReply} deleteReply={deleteReply} changeHashtagVote={changeHashtagVote} addHashtag={addHashtag} changeUpDownVote={changeUpDownVote}/> 
        )
      })}

      <Card className={classes.commentinput}>
        <CardContent>
          <Grid className={classes.authorinfo}>
            <Typography gutterBottom variant="body1" component="h2" style={{lineHeight: '32px', fontWeight:'800'}}>
                {displayname}
            </Typography>
          </Grid>
          <Grid container spacing={3}>
              <Grid item xs={11} >
                  <TextField
                  className={classes.inputtext}
                  id="comment-input"
                  multiline
                  rows={2}
                  defaultValue=""
                  variant="outlined"
                  onChange={handleChange}
                  style={{width: '100%'}}
                  fontSize="small"
                  />
              </Grid>
              <Grid item xs={1} style={{display: "grid", paddingLeft:0}} >
                  <Button className={classes.input} variant="outlined" style={{display: "flex", padding: 0 }} disabled={!validity} onClick={()=>{handleAddComment()}}>
                      Add
                  </Button>
              </Grid>
          </Grid>
        </CardContent>
    </Card>

    </div>
  );
}

